import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-map-view-toggle',
  standalone: true,
  imports: [CommonModule, CoreModule, RouterLinkActive, RouterLink, DictionaryNgrxModule],
  templateUrl: './map-view-toggle.component.html',
  styleUrls: ['./map-view-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapViewToggleComponent {
  // @Input() activeType: 'map' | 'grid' = 'grid';
}
